<template>
  <svg viewBox="-0.5 -0.5 21 21" aria-hidden="true">
    <rect x="3" y="3" width="14" height="14" rx="7" stroke="currentColor" stroke-width="3" fill="none" />
  </svg>
</template>
